export default "__VITE_ASSET__DbUjHzvg__"